
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "search.icon",
  "use": "search.icon-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"search.icon\"><g id=\"search.icon_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"search.icon_1.0_homepage_search-01\" transform=\"translate(-1106 -531)\" fill=\"#FFF\" fill-rule=\"nonzero\"><g id=\"search.icon_Group-7\" transform=\"translate(0 141)\"><g id=\"search.icon_Group-4\" transform=\"translate(674 293)\"><path d=\"M448.664 112.426l-4.104-4.128a7.001 7.001 0 00-.908-9.548 7.02 7.02 0 00-9.597.302 7.001 7.001 0 00-.303 9.587 7.02 7.02 0 009.559.907l4.085 4.08a.883.883 0 101.268-1.2zm-13.344-4.69a5.24 5.24 0 01-.655-6.612 5.253 5.253 0 016.36-1.945 5.242 5.242 0 01-1.95 10.095 5.224 5.224 0 01-3.774-1.51l.019-.028z\" id=\"search.icon_Shape\" /></g></g></g></g></symbol>"
});
    sprite.add(symbol);
    export default class SearchIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="search.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/search.icon.svg